import { roundPositiveAndScale } from 'src/Libs/system-data-handler/utils/transformers'

export const calculateHouseConsumption = (consumptionTotal: number, wallboxEnergyAll?: number, powermeterConsumption?: number): number => {
  return roundPositiveAndScale(consumptionTotal - (wallboxEnergyAll ?? 0) - (powermeterConsumption ?? 0), 1)
}

export const calculateSelfProduction = (consumptionTotal: number, netOut?: number): number => {
  return roundPositiveAndScale(consumptionTotal - (netOut ?? 0), 1)
}

export const calculateAutarky = (consumptionTotal: number, netOut?: number): number => {
  return roundPositiveAndScale(consumptionTotal - (netOut ?? 0), 1)
}

export const calculateDeration = (consumptionHouse: number, derateAtPower: number): number => {
  return roundPositiveAndScale(consumptionHouse + derateAtPower, 1)
}

export const calculateDCPowerTotal = (dcPowerSolar: number, powermeterProduction: number): number => {
  return roundPositiveAndScale(dcPowerSolar + powermeterProduction, 1)
}

export const calculateWallboxEnergyNetOut = (wallboxEnergyAll: number, wallboxEnergySolar: number): number => {
  return roundPositiveAndScale(wallboxEnergyAll - wallboxEnergySolar, 1)
}
